import { Form } from 'react-bootstrap';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { ReactComponent as PdfIcon } from '@/assets/img/pdf-icon.svg';

import './VaccinationCard.scss';
import { FileDetails } from '../types';
import Utils from '@/utils/util';
export type Vaccine = {
  taken: boolean;
  takenDate: string;
  expiryDate: string;
  type: string;
  fileDetails?: FileDetails;
};
type VaccinationCardProps = {
  title: string;
  description: string;
  data: Vaccine;
};
export const VaccinationCard = ({ title, description, data }: VaccinationCardProps) => {
  const [vaccineTaken, setVaccineTaken] = useState<boolean>(false);
  useEffect(() => {
    setVaccineTaken(data.taken ? true : false);
  }, []);
  return (
    <div className="vaccination-card">
      <div className="vaccination-desc">
        <h5>{title}</h5>
        <p>{description}</p>
        {data.fileDetails && data.fileDetails.fileUrl && (
          <div className="link">
            <a href={data.fileDetails.fileUrl} target="_blank" rel="noreferrer">
              <PdfIcon />
              <div className="file-details">
                <span>
                  {data.fileDetails.fileName ? data.fileDetails.fileName : 'Vaccination Document'}
                </span>
                <span>{Utils.getFileSize(data.fileDetails.fileSize)}</span>
              </div>
            </a>
          </div>
        )}
      </div>
      <div className="petsked-form vaccination-details">
        <div className="options">
          <Form.Check
            label="Taken"
            inline
            name={data.type}
            type="radio"
            checked={vaccineTaken}
            value={'true'}
            className="form-check-toggle"
            disabled
          />
          <Form.Check
            label="Not Taken"
            inline
            name={data.type}
            type="radio"
            checked={!vaccineTaken}
            value={'false'}
            className="form-check-toggle"
            disabled
          />
        </div>
        {vaccineTaken && (
          <div className="form-field">
            <label className="form-label">Taken On</label>
            <span className="datepicker-container">
              <input
                readOnly
                type="text"
                placeholder="Nil"
                value={data.takenDate ? moment(data.takenDate).format('DD-MMM-yyyy') : 'Nil'}
                className="cust-input-mobile" // a styling class
              />
            </span>
            <label className="form-label mt-3">Expiry On</label>

            <span className="datepicker-container">
              <input
                readOnly
                type="text"
                placeholder="Nil"
                value={data.expiryDate ? moment(data.expiryDate).format('DD-MMM-yyyy') : 'Nil'}
                className="cust-input-mobile" // a styling class
              />
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
